import { render } from "./WhyPopular.vue?vue&type=template&id=25789277&scoped=true"
import script from "./WhyPopular.vue?vue&type=script&lang=js"
export * from "./WhyPopular.vue?vue&type=script&lang=js"

import "./WhyPopular.vue?vue&type=style&index=0&id=25789277&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25789277"]])

export default __exports__